import {
  atom,
  selectorFamily,
  useRecoilCallback,
  useRecoilValue,
} from 'recoil';

const selectedParticipantsState = atom<Array<string>>({
  key: 'selected-participants',
  default: [],
});

const isSelectedState = selectorFamily<boolean, string>({
  key: 'is-selected-participant',
  get:
    (id) =>
    ({ get }) => {
      const selectedIds = get(selectedParticipantsState);
      return selectedIds.includes(id);
    },
});

export const useIsSelected = (id: string) => {
  return useRecoilValue(isSelectedState(id));
};

export const useSelectParticipant = () => {
  const selectedParticipants = useRecoilValue(selectedParticipantsState);

  const selectParticipant = useRecoilCallback(
    ({ set }) =>
      (sessionId: string) => {
        set(selectedParticipantsState, (state) => [...state, sessionId]);
      },
    []
  );

  const deselectParticipant = useRecoilCallback(
    ({ set }) =>
      (sessionId: string) => {
        set(selectedParticipantsState, (state) =>
          state.filter((id) => id !== sessionId)
        );
      },
    []
  );

  const selectAllParticipants = useRecoilCallback(
    ({ set }) =>
      (participants) => {
        set(selectedParticipantsState, participants);
      },
    []
  );

  const deselectAllParticipants = useRecoilCallback(
    ({ set }) =>
      () => {
        set(selectedParticipantsState, []);
      },
    []
  );

  return {
    selectParticipant,
    deselectParticipant,
    selectAllParticipants,
    deselectAllParticipants,
    selectedParticipants,
  };
};
